import apiSlice from '../api/api.slice';
import {
  IGetPreSignedUploadUrlRequest,
  IGetPreSignedUploadUrlResponse,
} from './attachment';

export const attachmentApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPreSignedUrl: builder.query<string, { attachmentId: string }>({
      query: (params) => ({
        url: '/api/v1/attachment/getPreSignedUrl',
        method: 'GET',
        params,
      }),
      transformResponse: (response: { status: string; signedURL: string }) =>
        response.signedURL,
    }),
    getPreSignedUploadUrl: builder.mutation<
      IGetPreSignedUploadUrlResponse[],
      IGetPreSignedUploadUrlRequest
    >({
      query: (data) => ({
        url: '/api/v1/attachment/getPreSignedUploadUrl',
        method: 'POST',
        body: data,
      }),
      transformResponse: (response: {
        attachments: IGetPreSignedUploadUrlResponse[];
      }) => response.attachments,
    }),
    deleteAttachment: builder.mutation<
      string,
      {
        attachmentId: string;
      }
    >({
      query: (data) => ({
        url: `/api/v1/attachment/deleteAttachment/${data.attachmentId}`,
        method: 'GET',
      }),
      transformResponse: (response: { status: string }) => response.status,
    }),
  }),
});
apiSlice.enhanceEndpoints({
  endpoints: {
    deleteAttachment: {
      invalidatesTags: ['Post'],
    },
  },
});

export const {
  useGetPreSignedUrlQuery,
  useLazyGetPreSignedUrlQuery,
  useDeleteAttachmentMutation,
  useGetPreSignedUploadUrlMutation,
} = attachmentApiSlice;
